import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Row,
  Col,
  Select,
  Input,
  DatePicker,
  Button,
  notification,
} from "antd";
import { creditNoteService, dropdownService, invoiceService } from "../../../../../services";
import MaterialLikeSelect from "../../../../../components/MaterialLikeSelect";
import MaterialLikeInput from "../../../../../components/MaterialLikeInput";
import MaterialLikeDatePicker from "../../../../../components/MaterialLikeDatePicker";
import MaterialLikeTextArea from "../../../../../components/MaterialLikeTextArea ";

function AddCreditNoteModal({ isVisible, setIsModalShow, creditNote, initialize }) {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [invoices, setInvoices] = useState([]);
  const [customers, setCustomers] = useState([])
  const handleCancel = () => {
    form.resetFields();
    setIsModalShow(false);
  };
  const getCustomer = async () => {
    setLoading(true)
    const response = await dropdownService.fetchCustomers();
    setLoading(false)
    setCustomers(response.data);

  };
  const fetchCustomerInvoicesData = async (id) => {
    setLoading(true);
    const response = await invoiceService.fetchCustomerInvoicesData(id);
    setLoading(false);
    if (response?.success) {
      setInvoices(response.data);
      form.setFieldValue("invoice", undefined); // reset invoice
    };
  }

  const handleOk = async (values) => {
    setLoading(true);
    const { CreditNumber, ...rest } = values;
    const data = {
      ...rest,
      issue_date: rest.issue_date.format("YYYY-MM-DD"),
    };
    const response = await creditNoteService.addCreditNote(data);
    if (response.success) {
      notification.success({
        message: "Successfully Added!",
        description: response.message,
        placement: "topRight",
      });
    }
    setLoading(false);
    initialize();
    handleCancel();
  };

  // useEffect(() => {
  //   form.setFieldsValue({
  //     CreditNumber: Number(creditNote[0]?.id) + 1,
  //   });
  //   getCustomer()
  // }, [creditNote]);

  
  useEffect(() => {
  if (isVisible) {
    form.setFieldsValue({
      CreditNumber: Number(creditNote[0]?.id) + 1,
    });
    getCustomer();
  }
}, [isVisible, creditNote]);


  return (
    <Modal
      title={<div style={{ width: "100%" }}>Add Credit Note</div>}
      open={isVisible}
      onCancel={handleCancel}
      footer={null}
      closable={true}
      width={500}
      style={{ padding: "15px" }}
    >
      <Form
        layout="vertical"
        form={form}
        onFinish={handleOk}
        requiredMark={false}
      >
        <Row gutter={24}>
          <Col span={24}>
            <Form.Item
              name="customer"
              rules={[
                { required: true, message: "Please select an Customer no" },
              ]}
            >
              <MaterialLikeSelect
                label="Customer Name"
                required
                value={form.getFieldValue("customer")}
                onChange={(value) => {
                  form.setFieldValue('customer', value)
                  fetchCustomerInvoicesData(value); // 🔥 API call
                }
                }
                options={customers?.map((customer) => ({
                  id: customer.id,
                  value: customer.id,
                  label: customer.name,
                }))}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="invoice"
              rules={[
                { required: true, message: "Please select an invoice number" },
              ]}
            >
              <MaterialLikeSelect
                label="Invoice Number"
                required
                loading={loading}
                value={form.getFieldValue("invoice")}
                onChange={(value) => form.setFieldValue('invoice', value)}
                options={invoices?.map((invoice) => ({
                  id: invoice.id,
                  value: invoice.id,
                  label: invoice.id,
                }))}
              />
              {/* <Select placeholder="Select Invoice #">
                {invoices.map((invoice) => (
                  <Select.Option key={invoice.id} value={invoice.id}>
                    {invoice.id}
                  </Select.Option>
                ))}
              </Select> */}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="CreditNumber"
              rules={[
                { required: true, message: "Please enter the credit number" },
              ]}
            >
              <MaterialLikeInput
                label="Credit Number"
                value={form.getFieldValue("CreditNumber")}
                onChange={(e) => form.setFieldValue("CreditNumber", e.target.value)}
                readOnly
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="amount"
              rules={[{ required: true, message: "Please enter the amount" }]}
            >
              <MaterialLikeInput
                label="Amount"
                value={form.getFieldValue("amount")}
                onChange={(e) => form.setFieldValue("amount", e.target.value)}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="issue_date"
              rules={[{ required: true, message: "Please select a date" }]}
            >
              <MaterialLikeDatePicker
                label="Date"
                required
                value={form.getFieldValue("issue_date")}
                onChange={(date) => form.setFieldValue("issue_date", date)}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name="description">
              <MaterialLikeTextArea
                label="Description"
                rows={5}
                value={form.getFieldValue("description")}
                onChange={(e) => form.setFieldValue("description", e.target.value)}
              />

            </Form.Item>
          </Col>
        </Row>
        <Col span={24}>
          <Form.Item style={{ marginTop: 20 }}>
            <Button
              type="primary"
              htmlType="submit"
              style={{ width: "100%" }}
              loading={loading}
            >
              Create Credit Note
            </Button>
          </Form.Item>
        </Col>
      </Form>
    </Modal>
  );
}

export default AddCreditNoteModal;
